import Vue from 'vue';
import VueI18n from 'vue-i18n';
// import VueGtm from 'vue-gtm';
import messages from './lang';
import App from './App.vue';
import router from './router';
import store from './store';
// import { consents } from './utils/borlabsCookie';

import './scss/index.scss';

// icon library
import 'vue-awesome/icons/info';
import 'vue-awesome/icons/times';
import 'vue-awesome/icons/bars';

Vue.config.productionTip = false;

/**
 * i18n congiguration
 * https://kazupon.github.io/vue-i18n/
 */

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'de',
  messages,
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

window.dataLayer = [];

/**
 * Init GTM
 */

// function getGTMID(hostname) {
//   console.log('Constent:', consents.marketing.includes('google-tag-manager'));
//   switch (hostname) {
//     case 'citygames-koeln.de':
//       return 'GTM-PSWP7ZC';
//     case 'citygames-berlin.de':
//       return 'GTM-WTPJ896';
//     case 'citygames-muenster.de':
//       return 'GTM-5MBJ8R8';
//     case 'citygames-duesseldorf.de':
//       return 'GTM-M4887G4';
//     case 'citygamesfrankfurt.de':
//       return 'GTM-TJFQXWX';
//     case 'citygames-flensburg.de':
//       return 'GTM-PCB6WTJ';
//     case 'citygames-bochum.de':
//       return 'GTM-WP5CR9Q';
//     case 'citygames-hamburg.de':
//       return 'GTM-PRM4KC8';
//     case 'citygames-bremen.de':
//       return 'GTM-PKBR6DP';
//     case 'citygames-hannover.de':
//       return 'GTM-P7M8NXB';
//     default:
//       return 'GTM-PSWP7ZC';
//   }
// }

// Vue.use(VueGtm, {
//   id: getGTMID(window.location.hostname),
//   enabled: consents.marketing.includes('google-tag-manager'),
//   debug: true,
//   loadScript: true,
// });
